import LoginFormV2 from "./SamlLoginForm";
export default LoginFormV2;
